export const AnonymousUserEmail = 'anonymous-proton@docs.proton.me'
export const AnonymousUserDisplayName = 'Anonymous User'
